import { CertificateType } from '../certeficate/types';
import { TAnswerTest, TResponseTestsQuestions } from '../interactive/types';

export interface TFinalTest {
  id: number;
  isDone: boolean;
  points: number;
  title: string;
  type: number;
  minPoints: number;
  quantity: number;
  questions: TResponseTestsQuestions[];
  myAnswers: TAnswerTest[] | null;
  certeficate?: CertificateType;
  endDate: Date;
  attempt_limit: number;
}

export interface TFinalTestState {
  data: TFinalTest | null;
  error: string | null;
  loading: boolean;
}

enum ActionTypes {
  GET_FINAL_TEST_R = 'GET_FINAL_TEST_R',
  GET_FINAL_TEST_S = 'GET_FINAL_TEST_S',
  GET_FINAL_TEST_E = 'GET_FINAL_TEST_E',

  SEND_FINAL_TEST_R = 'SEND_FINAL_TEST_R',
  SEND_FINAL_TEST_S = 'SEND_FINAL_TEST_S',
  SEND_FINAL_TEST_E = 'SEND_FINAL_TEST_E',
}

export default ActionTypes;
